import { TAppState } from '../../types/appState';
import { currentOpenChatSelector } from '../currentOpenChatSelector';

export function availableDatesSelector(state: TAppState) {
  const openChat = currentOpenChatSelector(state);

  const { checkin, checkout } = openChat?.availableDates || {};

  return { checkin, checkout };
}
